import * as actionTypes from '../actions/actionTypes';
import * as api from 'api'
import _ from 'lodash';

export const setSide = (side) => {
    return {
        type: actionTypes.SET_SIDE,
        side: side
    }
}

export const setModal = (element, id) => {
    return {
        type: actionTypes.SET_MODAL,
        element: element,
        id: id
    }
}

export const setSecModal = (element, id) => {
    return {
        type: actionTypes.SET_SEC_MODAL,
        element: element,
        id: id
    }
}

export const setInput = (id,id2) => {
    // console.log({id, id2})
    return {
        type: actionTypes.SET_INPUT,
        inputID: id,
        inputID2: id2
    }
}

export const setWindow = (window, body) => {
    return {
        type: actionTypes.SET_WINDOW,
        window: window,
        body: body
    }
}

export const setToasts = (toasts) => {
    return {
        type: actionTypes.SET_TOASTS,
        toasts: toasts || []
    }
}

export const setAccess = (showAccess, module, props) => {
    return dispatch => {
        dispatch({
            type: actionTypes.SET_ACCESS,
            showAccess: showAccess,
            access: module,
            accessProps: props
        })

        dispatch({
            type: actionTypes.SET_MODAL,
            element: null,
            id: null
        })
    }
}

export const uploadImg = (user, file) => {
    const filename = file.name;
    const metadata = {name: filename, type: 'profile_image'};
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", `${user['uid']}_${new Date().getTime()}`);
    formData.append("userId", user['uid'])
    formData.append("type", "profile_image")
    console.log('[uploadImg]', { user, file })
    console.log(formData.get('file'))
    return dispatch => {
        // api.uploadImg({ userId: user['uid'], file: formData, metadata })
        api.uploadImg(formData)
        .then(uploadRes => {
            const link = uploadRes.data['link']
            dispatch({type: actionTypes.UPLOAD_FILE, url: link})
        })
        .catch(uploadErr => {
            console.log('[uploadImg] Failed', uploadErr)
            dispatch({type: actionTypes.UPLOAD_ERROR})
        })
    }
}

export const uploadReset = () => {
    return ({type: actionTypes.UPLOAD_RESET})
}
